import styled from 'styled-components';

export const SimulatorLayout = styled.div`
  > * + * {
    margin-block-start: ${(props) =>
      props.theme.brand.spacing.simulatorLayout?.blockGap ?? '0'};
  }
`;

export const SimulatorHeader = styled.div<{isContentLayer?: boolean}>`
  padding-inline-start: ${(props) =>
    props.isContentLayer
      ? '0'
      : props.theme.brand.spacing.simulatorHeaderLayout?.inlineStart ?? '0'};
  padding-inline-end: ${(props) =>
    props.isContentLayer
      ? '0'
      : props.theme.brand.spacing.simulatorHeaderLayout?.inlineEnd ?? '0'};
`;
